import {
  Component,
  Input,
  ChangeDetectionStrategy,
  HostBinding,
} from "@angular/core";

@Component({
  selector: "icn-progressbar",
  templateUrl: "./progressbar.component.html",
  styleUrls: ["./progressbar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  @Input()
  value: number = 100;

  @Input()
  @HostBinding("class.flat")
  flat: boolean = false;

  @Input()
  @HostBinding("class.small")
  small: boolean = false;

  @Input()
  themeColor: "purple" | "cyan" | "red" | "green" = "purple";
}
